import { req } from './axiosFun';

/**
 * 代理管理（超管）
 * 所有接口均 POST，Content-Type: x-www-form-urlencoded，请求头自动携带 token
 * 返回 Result { code:0成功, msg, data }
 **/
// 代理管理-代理列表
export const agentList = (params) => { return req("post", "/customer/admin/agent/list", params) };
// 代理管理-新增代理
export const agentAdd = (params) => { return req("post", "/customer/admin/agent/add", params) };
// 代理管理-编辑代理
export const agentUpdate = (params) => { return req("post", "/customer/admin/agent/update", params) };
// 代理管理-重置密码
export const agentResetPwd = (params) => { return req("post", "/customer/admin/agent/resetPwd", params) };
// 代理管理-启用/停用
export const agentToggleStatus = (params) => { return req("post", "/customer/admin/agent/toggleStatus", params) };
// 代理管理-名下卡密
export const agentCards = (params) => { return req("post", "/customer/admin/agent/cards", params) };
// 代理管理-查询四种次数卡配额
export const agentQuotaList = (params) => { return req("post", "/customer/admin/agent/quota/list", params) };
// 代理管理-发放（追加）次数卡
export const agentQuotaAdd = (params) => { return req("post", "/customer/admin/agent/quota/add", params) };
// 代理管理-配额总览（总配额+当天上限/今日已开+按代理卡种点数）
export const agentQuotaOverview = (params) => { return req("post", "/customer/admin/agent/quota/overview", params) };
// 代理管理-配额调整（op: add 增加 / sub 扣减）
export const agentQuotaAdjust = (params) => { return req("post", "/customer/admin/agent/quota/adjust", params) };
// 代理管理-保存当天开卡上限（0=不限）
export const agentQuotaDailyMaxSave = (params) => { return req("post", "/customer/admin/agent/quota/dailyMaxSave", params) };
// 代理管理-保存某卡种点数（按代理独立）
export const agentQuotaCostSave = (params) => { return req("post", "/customer/admin/agent/quota/costSave", params) };
// 代理管理-删除代理（级联清理代理侧数据）
export const agentDelete = (params) => { return req("post", "/customer/admin/agent/delete", params) };
// 代理管理-查询某代理开出的用户
export const agentUsersList = (params) => { return req("post", "/customer/admin/agent/users", params) };



// WEBPACK FOOTER //
// ./src/api/agentMG.js